export const inProduction = window.location.hostname === 'localhost' ? false : true;
